import { Button, Layout, theme, Form, Input, Spin, notification, Checkbox, InputNumber } from "antd";

import React, { useState, useCallback, useEffect } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import RecipeApi from "../../common/Apis/RecipeApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import IngredientsApi from "../../common/Apis/IngredientsApi";
import DepartmentDropdown from "../../common/DropDowns/Department";

const EditRecipe = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [form] = Form.useForm();
  const [formAdd] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [refrigerated, Set_refrigerated] = React.useState(false);
  
  // Unit options that match backend enum
  const unitOptions = [
    { value: 'Kg', label: 'Kg' },
    { value: 'G', label: 'G' },
    { value: 'Milligram', label: 'Milligram' },
    { value: 'Tonne', label: 'Tonne' },
    { value: 'L', label: 'L' },
    { value: 'ML', label: 'ML' },
    { value: 'Kilolitre', label: 'Kilolitre' },
    { value: 'Box', label: 'Box' },
    { value: 'Packet', label: 'Packet' },
    { value: 'Piece', label: 'Piece' },
    { value: 'Tray', label: 'Tray' },
    { value: 'Bottle', label: 'Bottle' },
    { value: 'Can', label: 'Can' },
    { value: 'Bag', label: 'Bag' },
    { value: 'Portion', label: 'Portion' },
    { value: 'Serving', label: 'Serving' },
    { value: 'Slice', label: 'Slice' },
    { value: 'Cup', label: 'Cup' },
    { value: 'Container', label: 'Container' },
    { value: 'Pallet', label: 'Pallet' }
  ];

  // Function to extract group ID from batch code (number after # or just numeric part)
  const extractGroupId = (batchCode) => {
    if (!batchCode) return null;
    
    // First try to find pattern with # (e.g., T001T001A_ABC_Foods_#5555)
    const hashMatch = batchCode.match(/#(\d+)$/);
    if (hashMatch) {
      return hashMatch[1];
    }
    
    // If no #, try to extract numeric part from the end
    const numericMatch = batchCode.match(/(\d+)$/);
    if (numericMatch) {
      return numericMatch[1];
    }
    
    return null;
  };

  // Function to get display name - use the name field, not batch code
  const getDisplayName = (name, batchCode) => {
    // Always use the name field first
    if (name) {
      return name;
    }
    return batchCode || 'Unknown';
  };

  // Filter ingredients by grouping
  const filterIngredients = (ingredients) => {
    const grouped = {};
    const ungrouped = [];

    ingredients.forEach(ingredient => {
      const groupId = extractGroupId(ingredient.batchCode);
      
      if (groupId) {
        if (!grouped[groupId]) {
          grouped[groupId] = {
            id: ingredient.id,
            name: ingredient.name,
            batchCode: ingredient.batchCode,
            groupId: groupId,
            variants: [ingredient],
            displayName: ingredient.name // Use the name directly
          };
        } else {
          grouped[groupId].variants.push(ingredient);
        }
      } else {
        ungrouped.push({
          ...ingredient,
          displayName: ingredient.name || ingredient.batchCode
        });
      }
    });

    // Convert grouped to array with display name
    const groupedArray = Object.values(grouped).map(group => ({
      id: group.id,
      name: group.displayName,
      batchCode: group.batchCode,
      originalName: group.name,
      groupId: group.groupId,
      variants: group.variants,
      isGrouped: true,
      productId: group.productId
  }));

    // Convert ungrouped to array
    const ungroupedArray = ungrouped.map(item => ({
      ...item,
      isGrouped: false
    }));

    return [...groupedArray, ...ungroupedArray];
  };

  const [filteredIngredients, setFilteredIngredients] = useState([]);

  const getSingleRecipe = useCallback(() => {
  RecipeApi.SingleRecipe(id)
    .then((response) => {
      Set_refrigerated(response?.payload?.refrigeratedMeal);

      const mappedIngredients = response?.payload?.ingredientsDTO?.map((item) => ({
        id: item?.parentIngredientId,
        quantity: item?.quantity,
        unit: item?.unit,
        idNew: item?.id,
        parentIngredientId: item?.parentIngredientId,
      })) || [];

      setIngredients(mappedIngredients);

      // Accumulate all values first, then set once
      const valuesToSet = {
        productName: response?.payload?.recipeName,
        unit: response?.payload?.unit,
        recipeQuantity: response?.payload?.quantity,
        institutionId: response?.payload?.institutionDTO?.id,
        refrigerated: response?.payload?.refrigeratedMeal,
      };

      response?.payload?.ingredientsDTO?.forEach((item, index) => {
        valuesToSet[`Ingredient${index}`] = item?.parentIngredientId;
        valuesToSet[`Quantity${index}`] = item?.quantity;
        valuesToSet[`Ingredientunit${index}`] = item?.unit;
      });

      formAdd.setFieldsValue(valuesToSet);

      // Fetch allergens for each ingredient, then set all at once
      Promise.all(
        (response?.payload?.ingredientsDTO || []).map((item, index) =>
          IngredientsApi.SingleIngredients(item.parentIngredientId)
            .then((res) => ({
              index,
              allergenIds: res?.payload?.allergensDTO?.map((a) => a.id) || [],
            }))
            .catch(() => ({ index, allergenIds: [] }))
        )
      ).then((results) => {
        const allergenValues = {};
        results.forEach(({ index, allergenIds }) => {
          allergenValues[`Allergen${index}`] = allergenIds;
        });
        formAdd.setFieldsValue(allergenValues);
      });
    })
    .catch((err) => {
      console.log(err);
    });
}, []);

  const getIngredientAllergance = (Sid, IngredientsID) => {
  IngredientsApi.SingleIngredients(IngredientsID)
    .then((response) => {
      const allergenIds = response?.payload?.allergensDTO.map(item => item.id);
      formAdd.setFieldsValue({
        [`Allergen${Sid}`]: allergenIds,
      });
    })
    .catch((err) => console.log(err));
};

  const [Allergens, setAllergens] = React.useState([]);

  const getAllergens = useCallback(async () => {
  try {
    const firstResponse = await AllergensApi.ListAllergensApi(0, 10);
    const firstPageItems = firstResponse?.payloadDto || [];
    const totalPages = firstResponse?.totalPages || 1;

    if (totalPages <= 1) {
      setAllergens(firstPageItems);
      return;
    }

    const pageRequests = [];
    for (let page = 1; page < totalPages; page++) {
      pageRequests.push(AllergensApi.ListAllergensApi(page, 10));
    }

    const responses = await Promise.all(pageRequests);
    const allItems = [
      ...firstPageItems,
      ...responses.flatMap((res) => res?.payloadDto || []),
    ];

    setAllergens(allItems);
  } catch (err) {
    console.log(err);
  }
}, []);

  const getIngredient = useCallback(async () => {
  try {
    const firstResponse = await IngredientsApi.ListIngredients(0, 10);
    const firstPageItems = firstResponse?.payloadDto || [];
    const totalPages = firstResponse?.totalPages || 1;

    if (totalPages <= 1) {
      setFilteredIngredients(filterIngredients(firstPageItems));
      return;
    }

    const pageRequests = [];
    for (let page = 1; page < totalPages; page++) {
      pageRequests.push(IngredientsApi.ListIngredients(page, 10));
    }

    const responses = await Promise.all(pageRequests);
    const allItems = [
      ...firstPageItems,
      ...responses.flatMap((res) => res?.payloadDto || []),
    ];

    setFilteredIngredients(filterIngredients(allItems));
  } catch (err) {
    console.log(err);
  }
}, []);

  useEffect(() => {
    getAllergens();
    getIngredient();
    getSingleRecipe();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [getAllergens, getIngredient, getSingleRecipe]);
  
  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      recipeName: data.productName,
      unit: data.unit,
      quantity: data.recipeQuantity,
      ingredientsDTO: Ingredients,
      institutionDTO: {
        id: data.institutionId
      },
      refrigeratedMeal: refrigerated,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    RecipeApi.UpdateRecipe(id, formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Update Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/recipe");
      })
      .catch((err) => {
        console.log(err);
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleAddIngredients = () => {
    setIngredients([
      ...Ingredients,
      {
        id: "",
        quantity: "",
        unit: "",
        parentIngredientId: "",
      },
    ]);
  };

  const [Ingredients, setIngredients] = useState([]);
  
  const handleChangeQuantity = (ingredientsIndex, value) => {
    if (value < 0) {
      return;
    }
    const newIngredients = [...Ingredients];
    newIngredients[ingredientsIndex].quantity = value;
    setIngredients(newIngredients);
  };

  const handleChangeUnit = (ingredientsIndex, value) => {
    const newIngredients = [...Ingredients];
    newIngredients[ingredientsIndex].unit = value;
    setIngredients(newIngredients);
  };

  const handleChangeIngredient = (IngredientsIndex, value) => {
    const newIngredients = [...Ingredients];
    // Find the selected ingredient from filtered list
    const selectedIngredient = filteredIngredients.find(item => item.id === value);
    
    newIngredients[IngredientsIndex].id = value;
    newIngredients[IngredientsIndex].parentIngredientId = value;
    
    // If it's a grouped ingredient, we might want to store the group info
    if (selectedIngredient?.isGrouped) {
      newIngredients[IngredientsIndex].groupInfo = {
        groupId: selectedIngredient.groupId,
        variants: selectedIngredient.variants,
        displayName: selectedIngredient.name
      };
    }
    
    setIngredients(newIngredients);

    IngredientsApi.SingleIngredients(value).then((response) => {
      const setIndex = "Allergen" + IngredientsIndex;
      const allergenIds = response?.payload?.allergensDTO.map(item => item.id);
      const valuesToUpdate = {};
      valuesToUpdate[setIndex] = allergenIds;
      formAdd.setFieldsValue(valuesToUpdate);
    }).catch((err) => {
      console.log(err);
    });
  };

  const handleChangeAllergens = (IngredientsIndex, value) => {
    const newIngredients = [...Ingredients];
    newIngredients[IngredientsIndex].allergensDTO = value.map(id => ({ id }));
    setIngredients(newIngredients);
  };

  const handleRemoveIngredients = (IngredientsIndex, ingredientsId, parentID) => {
    const newIngredients = [...Ingredients];
    newIngredients.splice(IngredientsIndex, 1);
    setIngredients(newIngredients);

    if (parentID && ingredientsId && ingredientsId) {
      IngredientsApi.DeleteRecipeIngredients(id, ingredientsId, parentID).then((response) => {
        // Handle success if needed
      }).catch((err) => {
        console.log(err);
      });
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={formAdd}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name="productName"
                    label="Recipe Name :"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Product Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Recipe Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="unit"
                    label="Unit"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Unit",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-3"
                      placeholder="Select Unit"
                      options={unitOptions}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="recipeQuantity"
                    label="Quantity"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Quantity.",
                      },
                      {
                        validator: (_, value) => {
                          if (value < 0) {
                            return Promise.reject('Quantity cannot be negative');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                  >
                    <InputNumber
                      type="number"
                      placeholder="Quantity"
                      className="control-input"
                      style={{ width: '100%' }}
                      min={0}
                      step={0.01}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <DepartmentDropdown />
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="refrigerated"
                    className="text-lable"
                  >
                    <Checkbox
                      checked={refrigerated === true}
                      onChange={() => Set_refrigerated(!refrigerated)}
                    >
                      Is a refrigerated food
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <div>
                    <div className="d-flex py-3 pt-4">
                      <h5>Ingredients</h5>
                      <Button
                        className="mx-4 btn btn-primary my-0 py-1 px-4"
                        onClick={handleAddIngredients}
                      >
                        +
                      </Button>
                    </div>
                    {Ingredients.map((ingredient, ingredientsIndex) => (
                      <div key={ingredientsIndex}>
                        <Row gutter={16} className="mt-3">
                          <Col span={24}>
                            <div key={ingredientsIndex} className="d-flex align-items-center">
                              <h5 className="mb-0">Ingredients {ingredientsIndex + 1}</h5>
                              <Button
                             
                                className={`mx-4 btn btn-primary my-0 py-1 px-4 ${ingredientsIndex < 1 && "non-visble"}`}
                                onClick={() =>
                                  handleRemoveIngredients(ingredientsIndex, ingredient?.idNew, ingredient?.parentIngredientId)
                                }
                              >
                                -
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <div className="mx-4 py-2 Ingredients-New">
                          <Row gutter={16}>
                            <Col span={16}>
                              <Form.Item
                                name={`Ingredient${ingredientsIndex}`}
                                label={`Ingredient`}
                                className="text-lable "
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Ingredient.",
                                  },
                                ]}
                              >
                                {filteredIngredients && (
                                  <>
                                    <Select
                                      showSearch
                                      className="select-multi"
                                      placeholder="Select Ingredient"
                                      onChange={(value) =>
                                        handleChangeIngredient(
                                          ingredientsIndex,
                                          value
                                        )
                                      }
                                      filterOption={(input, option) => {
                                        if (!input) return true;
                                        const label = option?.label || '';
                                        return label.toLowerCase().includes(input.toLowerCase());
                                      }}
                                    >
                                      {filteredIngredients.map((option) => (
                                        <Select.Option 
                                          key={option.id} 
                                          value={option?.id}
                                          label={option.name}  // Add this line
                                        >
                                          {option.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={8}>
                              <Form.Item
                                name={`Ingredientunit${ingredientsIndex}`}
                                label="Unit"
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Unit",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select col-9"
                                  placeholder="Select Unit"
                                  onChange={(value) =>
                                    handleChangeUnit(
                                      ingredientsIndex,
                                      value
                                    )
                                  }
                                  options={unitOptions}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                name={`Quantity${ingredientsIndex}`}
                                label="Quantity"
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Quantity.",
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value < 0) {
                                        return Promise.reject('Quantity cannot be negative');
                                      }
                                      return Promise.resolve();
                                    }
                                  }
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  onChange={(value) =>
                                    handleChangeQuantity(
                                      ingredientsIndex,
                                      value
                                    )
                                  }
                                  placeholder="Quantity"
                                  className="control-input"
                                  style={{ width: '100%' }}
                                  min={0}
                                  step={0.01}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-2">
                            <Col span={16}>
                              <Form.Item
                                name={`Allergen${ingredientsIndex}`}
                                label="Allergen :"
                                className="text-lable pt-1 col-12"
                              >
                                {Allergens && (
                                  <>
                                    <Select
                                      mode="multiple"
                                      className="select-multi custom-select-New"
                                      placeholder="Select Allergens"
                                      onChange={(value) =>
                                        handleChangeAllergens(
                                          ingredientsIndex,
                                          value
                                        )
                                      }
                                      options={Allergens.map((option, index) => ({
                                        value: option?.id,
                                        label: option?.allergensName,
                                      }))}
                                    />
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditRecipe;